/* eslint-disable max-len */
import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Link Icon</title>
    <path
      d="M8.59998 10.6898C8.90201 11.0936 9.28736 11.4277 9.72987 11.6695C10.1724 11.9112 10.6617 12.055 11.1647 12.091C11.6677 12.127 12.1725 12.0545 12.6449 11.8782C13.1174 11.702 13.5464 11.4262 13.9029 11.0696L16.0128 8.95961C16.6534 8.29637 17.0079 7.40807 16.9998 6.48603C16.9918 5.564 16.622 4.68199 15.97 4.02999C15.318 3.37798 14.436 3.00815 13.514 3.00013C12.592 2.99212 11.7037 3.34657 11.0405 3.98715L9.83076 5.18982"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4 9.31013C11.098 8.90634 10.7126 8.57222 10.2701 8.33045C9.82758 8.08868 9.33825 7.94491 8.83528 7.90889C8.33232 7.87286 7.82749 7.94544 7.35503 8.12168C6.88258 8.29792 6.45356 8.57371 6.09706 8.93034L3.98713 11.0403C3.34657 11.7035 2.99212 12.5918 3.00013 13.5139C3.00815 14.4359 3.37798 15.3179 4.02997 15.9699C4.68197 16.6219 5.56396 16.9918 6.48598 16.9998C7.40801 17.0078 8.29629 16.6533 8.95952 16.0128L10.1622 14.8101"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
